import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import AppRoutes from "./routes";
import CartModal from "./components/Cart/CartModal";
import CookieBanner from "./components/CookieBanner/CookieBanner";
import { CookieProvider } from "./context/CookieContext";
import GTMConsentHandler from "./components/GTMConsentHandler";
import { PopupProvider } from "./context/PopupContext";
import PopupMenu from "./components/PopupMenu/PopupMenu";
import { PopupFormProvider } from "./context/PopupFormContext";
import PopupForm from "./components/PopupForm/PopupForm";
import ClarityAnalytics from "./components/ClarityAnalytics";
// import ZadarmaWidget from "./components/ZadarmaWidget";
import FloatingCallButton from "./components/FloatingCallButton/FloatingCallButton";

const localeMap: Record<string, string> = {
  de: "de_DE",
  ua: "uk_UA",
  pl: "pl_PL",
  cz: "cs_CZ",
};

const App = () => {
  const { i18n } = useTranslation();

  useEffect(() => {
    document.documentElement.lang = i18n.language;

    let metaOgLocale = document.querySelector('meta[property="og:locale"]');
    if (!metaOgLocale) {
      metaOgLocale = document.createElement("meta");
      metaOgLocale.setAttribute("property", "og:locale");
      document.head.appendChild(metaOgLocale);
    }
    metaOgLocale.setAttribute("content", localeMap[i18n.language] || "de_DE");
  }, [i18n.language]);

  return (
    <PopupProvider>
      <PopupFormProvider>
        <CookieProvider>
          <AppRoutes />
          <CartModal />
          <CookieBanner />
          <PopupMenu />
          <PopupForm />
          <FloatingCallButton />
          <ClarityAnalytics />
          {/* <ZadarmaWidget /> */}
          <GTMConsentHandler />
        </CookieProvider>
      </PopupFormProvider>
    </PopupProvider>
  );
};

export default App;
